import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { S as StepContainer, P as PreLine, C as Circle, a as PostLine, b as Content, L as LabelWrapper } from './Step.styles-CU7DC8Tp.js';
import { S as STATUS } from './constants-d5DDIlHP.js';

const Step = ({
  children,
  status = 'future',
  label = '',
  isVertical = false,
  inlineLabel = true,
  statusDescriptions = {},
  stepNumber,
  icons,
  numbered = true,
  isFirstStep = false,
  isLastStep = false,
  ...rest
}) => {
  var _statusDescriptions$s;
  const renderIconNode = () => {
    if (icons && status === STATUS.COMPLETED) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, icons.completed);
    }
    if (!numbered) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, stepNumber);
  };
  return /*#__PURE__*/React__default.createElement(StepContainer, _extends({
    "aria-label": (_statusDescriptions$s = statusDescriptions === null || statusDescriptions === void 0 ? void 0 : statusDescriptions[status]) !== null && _statusDescriptions$s !== void 0 ? _statusDescriptions$s : undefined,
    $isVertical: isVertical,
    $inlineLabel: inlineLabel
  }, rest), !isFirstStep && !isVertical && !inlineLabel && /*#__PURE__*/React__default.createElement(PreLine, null), /*#__PURE__*/React__default.createElement(Circle, {
    $status: status,
    $isVertical: isVertical,
    $inlineLabel: inlineLabel
  }, renderIconNode()), !isLastStep && /*#__PURE__*/React__default.createElement(PostLine, {
    $isVertical: isVertical,
    $inlineLabel: inlineLabel
  }), /*#__PURE__*/React__default.createElement(Content, {
    $isVertical: isVertical,
    $inlineLabel: inlineLabel,
    $status: status
  }, children !== null && children !== void 0 ? children : label && /*#__PURE__*/React__default.createElement(LabelWrapper, {
    renderAs: "span",
    $status: status
  }, label)));
};

export { Step as S };
//# sourceMappingURL=Step-CZF0jmx3.js.map
